import { useCallback, useEffect, useMemo, useState } from 'react';
import { gate } from 'hub-http/gates';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { getFeatureWithRPC } from '../../common/api/featuresApi';
import { getUserInfo } from '../../common/api/getUserInfo';
import { track } from '../../common/eventTracking/tracker';
import { TrialActivationSuccessModal } from './TrialActivationSuccessModal';
import { TrialActivationModal } from './redesign/TrialActivationModal';
import { jsx as _jsx } from "react/jsx-runtime";
const TrialActivationSuccessContainer = ({
  onSuccess,
  onClose,
  upgradeData,
  showTrialLoadingState
}) => {
  const [featureData, setFeatureData] = useState({
    feature: undefined,
    fetched: false
  });
  const [isUngatedForTrialActivationPrompt, setIsUngatedForTrialActivationPrompt] = useState(false);
  const [loading, setLoading] = useState(true);
  const normalizedUpgradeData = useMemo(() => Object.assign({}, upgradeData, {
    apiName: upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct]
  }), [upgradeData]);
  const handleClose = useCallback(() => {
    track('trialModalInteraction', Object.assign({
      action: 'clicked close button'
    }, getUpgradeDataTrackingProperties(upgradeData), {
      trialId: upgradeData.trialId,
      duration: upgradeData.duration
    }));
    if (onClose) {
      onClose();
    }
  }, [onClose, upgradeData]);
  useEffect(() => {
    getUserInfo().then(userInfo => {
      setIsUngatedForTrialActivationPrompt(userInfo.gates.includes(gate('HiC::TrialActivationPrompt::Redesign')));
      setLoading(false);
    }).catch(() => {
      setIsUngatedForTrialActivationPrompt(false);
      setLoading(false);
    });
  }, []);
  useEffect(() => {
    if (upgradeData.feature) {
      getFeatureWithRPC({
        shortName: upgradeData.feature
      }).then(feature => {
        setFeatureData({
          feature,
          fetched: true
        });
      }).catch(error => {
        setFeatureData({
          feature: undefined,
          fetched: true
        });
        console.error(error);
      });
    } else {
      setFeatureData({
        feature: undefined,
        fetched: true
      });
    }
  }, [upgradeData]);
  if (isUngatedForTrialActivationPrompt === undefined || loading) {
    return null;
  }
  if (isUngatedForTrialActivationPrompt) {
    return /*#__PURE__*/_jsx(TrialActivationModal, {
      onSuccess: onSuccess,
      onClose: handleClose,
      modalRoot: document.body,
      upgradeData: normalizedUpgradeData,
      featureData: featureData.feature
    });
  }
  return /*#__PURE__*/_jsx(TrialActivationSuccessModal, {
    showTrialLoadingState: showTrialLoadingState && !featureData.fetched,
    onSuccess: onSuccess,
    upgradeData: upgradeData,
    featureData: featureData.feature
  });
};
export default TrialActivationSuccessContainer;